/**
 * Initialize select widgets
 */
export function initSelectWidget() {
	const widgets = document.querySelectorAll(".select-widget");
	widgets.forEach(function (widget) {
		const btn = widget.querySelector(".select-widget__button");
		const drop = btn.nextElementSibling;

		var escapeCallback = function (event) {
			if (event.type === "keyup" && event.key === "Escape") {
				closeWidget();
			}
		};
		var clickoutCallback = function (event) {
			if (!widget.contains(event.target)) {
				closeWidget();
			}
		};

		function closeWidget() {
			btn.setAttribute("aria-expanded", false);
			drop.hidden = true;
			document.removeEventListener("keyup", escapeCallback);
			document.removeEventListener("click", clickoutCallback);
		}

		function openWidget() {
			btn.setAttribute("aria-expanded", true);
			drop.hidden = false;
			document.addEventListener("keyup", escapeCallback);
			document.addEventListener("click", clickoutCallback);
		}

		btn.onclick = () => {
			if (btn.getAttribute("aria-expanded") === "true") {
				closeWidget();
			} else {
				openWidget();
			}
		};
	});
}
